import { ENABLE_SHIPPING_ADDRESS_MODAL } from './types';
import { disableBodyScroll } from '../../util';

const enableShippingAddressModal = () => {
  disableBodyScroll();
  return { type: ENABLE_SHIPPING_ADDRESS_MODAL };
};

export default enableShippingAddressModal;



// WEBPACK FOOTER //
// ./src/actions/modals/enableShippingAddressModal.js